import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ui-kit-brands" }
const _hoisted_2 = { class: "ui-kit-brands__text" }
const _hoisted_3 = { class: "ui-kit-brands__text" }
const _hoisted_4 = { class: "ui-kit-brands__row --wrap --line" }
const _hoisted_5 = { class: "logo-container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "logo-container" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "logo-container" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "ui-kit-brands__text" }
const _hoisted_12 = { class: "ui-kit-brands__row --wrap --line" }
const _hoisted_13 = { class: "name-container" }
const _hoisted_14 = { class: "ui-kit-brands__row --wrap --line" }
const _hoisted_15 = { class: "logo-container" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "logo-container" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "logo-container" }
const _hoisted_20 = ["src"]

import { useStore } from "@/store";

import { computed } from "vue";
import { PropType } from "@vue/runtime-core";
import { BrandConfig } from "@/struct/BrandsConfigStruct";
import { defaultBrand } from "../../config/brands";


export default /*@__PURE__*/_defineComponent({
  __name: 'UiKitBrands',
  props: {
  testConfigDataBrand: {
    type: Object as PropType<BrandConfig>,
    required: true,
  },
},
  setup(__props) {

const store = useStore();
const currentRealBrand = computed(() => store.state.brand.operatorSource);
const configDataBrand = computed(() => store.getters["brand/configDataBrand"]);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "ui-kit-brands__head" }, [
      _createElementVNode("span", null, "Brands ")
    ], -1)),
    _createElementVNode("p", _hoisted_2, " Дефолтный бренд на сайте (используется в неавторизованной зоне): " + _toDisplayString(_unref(defaultBrand)) + ". ", 1),
    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "ui-kit-brands__text" }, " Дефолтный конфиг в store getters: configDataDefaultBrand. ", -1)),
    _createElementVNode("p", _hoisted_3, " Текущий бренд на сайте: " + _toDisplayString(currentRealBrand.value), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[0] || (_cache[0] = _createElementVNode("p", null, "logo", -1)),
        _createElementVNode("img", {
          src: configDataBrand.value.assets.logo,
          alt: "Логотип"
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, "logoMobile", -1)),
        _createElementVNode("img", {
          src: configDataBrand.value.assets.mobileLogo,
          alt: "Логотип"
        }, null, 8, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[2] || (_cache[2] = _createElementVNode("p", null, "loader", -1)),
        _createElementVNode("img", {
          src: configDataBrand.value.assets.loader,
          alt: "Загрузка"
        }, null, 8, _hoisted_10)
      ])
    ]),
    _createElementVNode("p", _hoisted_11, " Тестовый бренд в UI-KIT: " + _toDisplayString(__props.testConfigDataBrand.id), 1),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[3] || (_cache[3] = _createTextVNode(" Добро пожаловать")),
        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
        _createTextVNode("в " + _toDisplayString(__props.testConfigDataBrand.name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _cache[5] || (_cache[5] = _createElementVNode("p", null, "logo", -1)),
        _createElementVNode("img", {
          src: __props.testConfigDataBrand.assets.logo,
          alt: "Логотип"
        }, null, 8, _hoisted_16)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _cache[6] || (_cache[6] = _createElementVNode("p", null, "logoMobile", -1)),
        _createElementVNode("img", {
          src: __props.testConfigDataBrand.assets.mobileLogo,
          alt: "Логотип"
        }, null, 8, _hoisted_18)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[7] || (_cache[7] = _createElementVNode("p", null, "loader", -1)),
        _createElementVNode("img", {
          src: __props.testConfigDataBrand.assets.loader,
          alt: "Загрузка"
        }, null, 8, _hoisted_20)
      ])
    ])
  ]))
}
}

})